import ChangeReport from './ChangeReport';
import Discovery from './Discovery';
import ReportState from './ReportState';

export default {
    ChangeReport,
    Discovery,
    ReportState,
};
